import { useCallback } from 'react';
import useAxios from '@Apis/useAxios';
import {
    GET_MEMBER_INBODY_OPTIONS,
    GET_MEMBER_INBODY_RESULT,
    GET_MEMBER_INBODY_RESULT_PAGE,
    GET_MEMBER_INBODY_TRANSCRIPT_PAGE,
    GET_MEMBER_SINGLE_TRANSCRIPT_PAGE,
    GET_MEMBER_MEASURE_BODY_EVALUATION,
    GET_MEMBER_MEASURE_BODY_EVALUATION_PAGE,
    GET_MEMBER_INBODY_COMPARE_RECENT,
    GET_MEMBER_INBODY_COMPARE_PAST,
    GET_MEMBER_INBODY_DASHBOARD,
    GET_MEMBER_INBODY_DASHBOARD_TREND,
} from '@Apis/apiPath';

const useMemberInbodyApi = () => {
    const Axios = useAxios();

    const getMemberInbodyOptionsApi = useCallback(
        async () => {
            const resp = await Axios.get(GET_MEMBER_INBODY_OPTIONS);
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    const getMemberInbodyResultApi = useCallback(
        async (measureID) => {
            const resp = await Axios.get(GET_MEMBER_INBODY_RESULT(measureID));
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    const getMemberInbodyResultPageApi = useCallback(
        async (measureID) => {
            const resp = await Axios.get(GET_MEMBER_INBODY_RESULT_PAGE(measureID));
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    const getMemberInbodyTranscriptPageApi = useCallback(
        async (measureID) => {
            const resp = await Axios.get(GET_MEMBER_INBODY_TRANSCRIPT_PAGE(measureID));
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    const getMemberSingleTranscriptPageApi = useCallback(
        async (tokenKey) => {
            const resp = await Axios.get(GET_MEMBER_SINGLE_TRANSCRIPT_PAGE(tokenKey));
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    const getMemberMeasureBodyEvaluationApi = useCallback(
        async (measureID) => {
            const resp = await Axios.get(GET_MEMBER_MEASURE_BODY_EVALUATION(measureID));
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    const getMemberMeasureBodyEvaluationPageApi = useCallback(
        async (measureID) => {
            const resp = await Axios.get(GET_MEMBER_MEASURE_BODY_EVALUATION_PAGE(measureID));
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    const getMemberInbodyCompareRecentApi = useCallback(
        async () => {
            const resp = await Axios.get(GET_MEMBER_INBODY_COMPARE_RECENT());
            return resp;
        },
        // eslint-disable-next-line
        [],
    );
    
    const getMemberInbodyComparePastApi = useCallback(
        async (compareID) => {
            const resp = await Axios.get(GET_MEMBER_INBODY_COMPARE_PAST(compareID));
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    const getMemberInbodyDashboardApi = useCallback(
        async () => {
            const resp = await Axios.get(GET_MEMBER_INBODY_DASHBOARD);
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    const getMemberInbodyDashboardTrendApi = useCallback(
        async (trendType) => {
            const resp = await Axios.get(GET_MEMBER_INBODY_DASHBOARD_TREND(trendType));
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    return {
        getMemberInbodyOptionsApi,
        getMemberInbodyResultApi,
        getMemberInbodyResultPageApi,
        getMemberInbodyTranscriptPageApi,
        getMemberSingleTranscriptPageApi,
        getMemberMeasureBodyEvaluationApi,
        getMemberMeasureBodyEvaluationPageApi,
        getMemberInbodyCompareRecentApi,
        getMemberInbodyComparePastApi,
        getMemberInbodyDashboardApi,
        getMemberInbodyDashboardTrendApi,
    };
};

export default useMemberInbodyApi;
